import BasePropertyView from 'BasePropertyView.js';
import util from 'util/Util.js';
import nameTemplate from 'report/properties/main/value.ejs';
import MainFormulaModal from 'common-views/MainFormulaModalView.js';
import $ from 'jquery';
import listService from 'ListService';
import eventBus from 'EventBus.js'


class MainValueView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change select[name=dataAggregate],select[name=dataValue],input[type=checkbox]' :'updateValues',
            'click #valueFormula' :'updateFormulaValue',
            'change select[name=format]':'processFormatSelection',
            'change input[name=decimals],input[name=symbol],select[name=decimalSeparator],select[name=thousandSeparator]':'changeFormatProperty',
            'change select[name=dateFormat]':'changeFormatProperty',
            'change select[name=24Hour],input[name=showSeconds]':'changeFormatProperty',
            'change input[name=yesValue],input[name=noValue]':'changeFormatProperty',
            'change input[name=percentageDecimals]':'changeFormatProperty',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        if (this.model.get('respectDynamicFilter') === undefined) {
            this.model.set('respectDynamicFilter', true, {silent: true})
        }

        this.loadFormatOption();

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    loadFormatOption() {
        // load based on format

        let currentFormat = this.model.get('currentFormat');
        const format =this.model.get('format');
        const vals = this.model.get('formatOption').split('|');

        switch (format){
            case 'none':
                break;
            case 'number':
                currentFormat.decimals = vals[0];
                currentFormat.decimalSeparator = vals[1];
                currentFormat.thousandSeparator = vals[2];
                currentFormat.symbol = vals[3];
                break;
            case 'date':
                currentFormat.dateFormat = vals[0];
                break;
            case 'time':
                currentFormat.hour24 = vals[0];
                currentFormat.showSeconds = vals[1];
                break;
            case 'boolean':
                currentFormat.yesValue = vals[0];
                currentFormat.noValue = vals[1];
                break;
            case 'percentage':
                currentFormat.percentageDecimals = vals[0];
                break;
        }

        this.model.set('currentFormat', currentFormat, {silent:true});

    }
    setFormatOptions() {
        let currentFormat = this.model.get('currentFormat');
        const format =this.model.get('format');
        let formatOption = '';
        switch (format){
            case 'none':
                break;
            case 'number':
                formatOption = currentFormat.decimals + '|' + this.getSeparatorChar(currentFormat.decimalSeparator) + '|' + this.getSeparatorChar(currentFormat.thousandSeparator)  + '|' + currentFormat.symbol;
                break;
            case 'date':
                formatOption = currentFormat.dateFormat;
                break;
            case 'time':
                formatOption = currentFormat.hour24 + '|' + currentFormat.showSeconds;
                break;
            case 'boolean':
                formatOption = currentFormat.yesValue + '|' + currentFormat.noValue;
                break;
            case 'percentage':
                formatOption = currentFormat.percentageDecimals;
                break;
        }

        this.model.set('formatOption', formatOption, {silent:true});
    }

    updateValues(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = propName === 'respectDynamicFilter' ? ev.currentTarget.checked :  ev.currentTarget.value;
        const colid = "0";

        if (propName === 'dataValue' || propName === 'dataAggregate') {
            if (propName === 'dataAggregate') {
                this.updateColumnProperty(colid, 'aggregation', propVal);
                this.updateReportingMetaDataColumn(colid, 'aggregation', propVal);
            } else {
                const dataType = ev.currentTarget.options[ev.currentTarget.selectedIndex].attributes.dataType.value;
                this.updateColumnProperty(colid, 'fieldId',listService.getCleanedId( propVal));
                this.updateColumnProperty(colid, 'fieldDataType', dataType);
                this.updateReportingMetaDataColumnField(colid, listService.getCleanedId(propVal), dataType);
            }
        }

        this.model.set(propName, propVal);
    }

    changeFormatProperty(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        let currentFormat = this.model.get('currentFormat');
        //currentFormat.type=$(ev.currentTarget).parent().parent().parent().prop('id');
        currentFormat[propName] = propVal;
        if (this.getNameSeparator(currentFormat.decimalSeparator) === this.getNameSeparator(currentFormat.thousandSeparator)) {
            currentFormat.thousandSeparator = 'space';
        }
        //this.initializeFormatValues(currentFormat);
        this.model.set('currentFormat', currentFormat);

        this.setFormatOptions();
        this.loadFormat();
        this.applyFormat();
        eventBus.trigger('ValueControlPropertyChanged');
    }

    initializeFormatValues(format){
        let currentFormat = this.model.get('currentFormat');
        switch(format){
            case 'number':
                currentFormat['decimals']='2';
                currentFormat['decimalSeparator']='point';
                currentFormat['symbol']='';
                currentFormat['thousandSeparator']='space';
                break;
            case 'date':
                currentFormat['dateFormat']='ddmmyy';
                break;
            case 'time':
                currentFormat['hour24']=true;
                currentFormat['showSeconds']=false;
                break;
                
            case 'boolean':
                currentFormat['yesValue']='';
                currentFormat['noValue']='';
                break;
            case 'percentage':
                currentFormat['percentageDecimals']='2';
                break;
        }
        this.model.set('currentFormat',currentFormat);
    }

    processFormatSelection(ev){
        const propVal = ev.currentTarget.value;
        let sectionElementChosen=$(this.$el).find(`#${propVal}`);
        // Cleaning First
        let sectionElements=$(this.$el).find('.show-details');
        sectionElements.removeClass('hide').addClass('hide');
        this.model.set('format',propVal,{silent:true});
        sectionElementChosen.removeClass('hide');
        this.initializeFormatValues(propVal);
        this.loadFormat();
        this.applyFormat();
        this.setFormatOptions();
        eventBus.trigger('ValueControlPropertyChanged');
    }

    applyFormat(){
        const format = this.model.get('format');
        let currentFormat = this.model.get('currentFormat');
        let currentValue = this.model.get('value');
        let formattedValue = this.model.get('formattedValue');
        switch (format){
            case 'none':
                formattedValue = currentValue;
                break;
            case 'number':
                formattedValue = parseFloat(currentValue).toFixed(parseInt(currentFormat.decimals));
                formattedValue = currentFormat.symbol !== '' ? currentFormat.symbol+formattedValue : formattedValue;
                formattedValue = formattedValue.replace('.', this.getSeparatorChar(currentFormat.decimalSeparator))
                                             .replace(',', this.getSeparatorChar(currentFormat.decimalSeparator));
                break;
            case 'date':
                formattedValue='';
                break;
            case 'time':
                formattedValue='';
                break;
            case 'boolean':
                formattedValue=currentFormat.noValue;
                break;
            case 'percentage':
                formattedValue = parseFloat(currentValue).toFixed(parseInt(currentFormat.percentageDecimals));
                formattedValue = '%'+formattedValue;
                break;
        }

        this.model.set('formattedValue', formattedValue);
    }

    getSeparatorChar(separator){
        switch (separator){
            case 'comma':
            case ',':
                return ',';
            case 'point':
            case '.':
                return '.';
            case 'space':
            case ' ':
            case '':
                return ' ';
        }
    }

    getNameSeparator(separator){
        switch (separator){
            case 'comma':
            case ',':
                return 'comma';
            case 'point':
            case '.':
                return 'point';
            case 'space':
            case ' ':
            case '':
                return 'space';
        }
    }

    updateFormulaValue(ev){
        this.model.set('type', 'DataSource', {silent:true});
        this.model.set('title', 'Column Formula', {silent:true});
        var formulaModal=new MainFormulaModal({model:this.model, config:{}});
        formulaModal.render().then((data)=>{
            if (ev.target.name === 'valueFormula'){
                this.updateColumnProperty('0', 'fieldId', 'Formula');
                this.updateColumnProperty('0', 'fieldDataType', 'NVARCHAR(400)');
                this.updateReportingMetaDataColumnField('0', 'Formula', 'NVARCHAR(400)', data); 
                this.updateColumnExpression('0');
                this.model.set( 'valueSecondary', 'Formula', {silent:true} );
            }
            this.model.set(ev.target.name,data, {silent:true});
            this.render();
        }).catch(e => {
            console.log(e);
        });
    }

    updateColumnExpression(rowid) {      
        const formulaParameter = this.model.get('formulaParameter');
        const columns = this.model.get('Columns');

        if (formulaParameter && rowid === '0'){
            if (!columns.Column[rowid].EXPR){
                columns.Column[rowid].EXPR = {};
                columns.Column[rowid].EXPR.id = formulaParameter.id;
                columns.Column[rowid].EXPR.type = formulaParameter.type;
                columns.Column[rowid].EXPR.arguments = formulaParameter.arguments;                
            }else{
                columns.Column[rowid].EXPR.id = formulaParameter.id;
                columns.Column[rowid].EXPR.type = formulaParameter.type;
                columns.Column[rowid].EXPR.arguments = formulaParameter.arguments;
            }
        }
      }

    loadFormat(){
        let currentElement=$(this.el);
        const format = this.model.get('format');
        let currentFormat = this.model.get('currentFormat');
        switch(format){
            case 'none':break;
            case 'number':
                    currentElement.find('input[name=decimals]').val(currentFormat.decimals);
                    currentElement.find('input[name=symbol]').val(currentFormat.symbol);
                    $('#decimalSeparator').val(this.getNameSeparator(currentFormat.decimalSeparator));
                    $('#thousandSeparator').val(this.getNameSeparator(currentFormat.thousandSeparator));
                break;
            case 'date':
                currentElement.find(`option[value='${currentFormat.dateFormat}']`).prop('selected',true);
                break;
            case 'time':
                currentElement.find(`input[name='24Hour']`).prop('checked',currentFormat['24Hour']);
                currentElement.find(`input[name='showSeconds']`).prop('checked',currentFormat['showSeconds']);
                break;
            case 'boolean':
                currentElement.find(`input[name='yesValue']`).val(currentFormat.yesValue);
                currentElement.find(`input[name='noValue']`).val(currentFormat.noValue);
                break;
            case 'percentage':
                currentElement.find(`input[name='percentageDecimals']`).val(currentFormat.percentageDecimals);
                break;
        }
    }

    // Only want to list Fields marked as InUse (Configured in the DataSource)
    loadFieldsFromDatasource( dsId ) {
        const ds = listService.getDataSources(dsId);

        if (ds && ds.Fields && ds.Fields.Field) {

            const fieldValueEl = $('#dataValue');
            _.forEach(ds.Fields.Field, (field) => {
                if (util.isTrue(field.inUse)) {
                    let fname = '';

                    switch (field.id) {
                        case 'CreateDate':
                            fname = 'Meta - Last Submission Date';
                            break;
                        case 'E':
                            fname = 'Meta - Instance Number';
                            break;
                        case 'FormInstanceGUID':
                            fname = 'Meta - Instance ID';
                            break;
                        case 'FormInstanceId':
                            fname = 'Meta - Link';
                            break;
                        case 'MajorVersion':
                            fname = 'Meta - Version Major';
                            break;
                        case 'MinorVersion':
                            fname = 'Meta - Version Minor';
                            break;
                        case 'Name':
                            fname = 'Meta - Instance Name';
                            break;
                        case 'ParentGUID':
                            fname = 'Meta - Parent Instance ID';
                            break;
                        case 'StageName':
                            fname = 'Meta - Stage';
                            break;

                        default:
                            fname = field.name.replace('|',' - ');
                            break;
                    }

                    const elOpt2 = new Option((field.displayName.trim() || fname), listService.cleanId(field.id));
                    fieldValueEl[0].options[fieldValueEl[0].options.length] = elOpt2;
                    elOpt2.setAttribute("dataType", field.dataType);
                }
            });

            $('#dataValue').append('<optgroup label="──────────"></optgroup>');
            $('#dataValue').append('<option value="Formula">Formula</option>');
        }
    }

    setFieldsFromColumnZero() {
        const properties = this.model.get('Columns').Column[0].Properties;
        this.model.set({
            'dataValue': properties.fieldId,
            'dataAggregate': properties.aggregation
        }, {silent: true});
    }

    updateColumnProperty(rowid, propName, propVal) {
        const columns = this.model.get('Columns');

        columns.Column[rowid].Properties[propName] = propVal;
    }

    // Look up Column by ID and set properties
    updateReportingMetaDataColumnField(rowid, dsFieldId, dataType, data ) {
        const md = listService.getReportingMetaData(this.model.get('id'));

        if (md.Columns) {
            _.forEach(md.Columns, (col) => {
                if (col.id.toString() === rowid.toString()) {
                    if( data && data.arguments && util.isChart(this.model.get('factoryKey')) ){
                        col.Expression.id = data.id;
                        col.Expression.type = data.type;
                        col.Expression.Argument = data.arguments;
                    }else{
                        col.Expression.Argument = {type: 'reporting_datasourceField', value: dsFieldId, dataType: dataType};
                    }
                }
            });

        }

    }

    updateReportingMetaDataColumn(rowid, propName, propVal) {
        const md = listService.getReportingMetaData(this.model.get('id'));

        if (md.Columns) {
            _.forEach(md.Columns, (col) => {
                if (col.id.toString() === rowid.toString()) {
                    col[propName] = propVal;
                }
            });
        }
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
            $(`select[name="valuePrimary"] option[value="${this.model.get("valuePrimary")}"]`).prop('selected',true);
            $(`select[name="valueSecondary"] option[value="${this.model.get("valueSecondary")}"]`).prop('selected',true);
            $(`select[name="format"] option[value="${this.model.get("format")}"]`).prop('selected',true);

            let respectDynamicFilter = util.isTrue(this.model.get('respectDynamicFilter'));
            $(`input[name='respectDynamicFilter']`).prop('checked', respectDynamicFilter );

            let currentFormat = this.model.get('format');
            $(this.$el).find(`#${currentFormat}`).removeClass('hide');

            this.loadFormat();
        }

        this.loadFieldsFromDatasource( listService.cleanId( this.model.get('dataSourceId') ));

        this.setFieldsFromColumnZero();

        let dataValue = this.model.get('dataValue');

        if(dataValue.toLowerCase() !== "formula"){
            dataValue = listService.cleanId(dataValue)
        }
        else{
            dataValue = dataValue[0].toUpperCase() + dataValue.slice(1); //In case the F in formula is in lower case
        }

        $(`#dataValue option[value='${dataValue}']`).prop('selected', true);
        $(`#dataAggregate option[value='${this.model.get('dataAggregate')}']`).prop('selected', true);

        this.delegateEvents();
        return this;
    }

}

export default MainValueView;
